// What a person holds can change while a page is open (QA-682): the owner takes a permission back,
// changes their roles or limits one, or changes a role they hold. The app reads the session again on
// the live stream's word for it, or on any refused call, and the nav and the page follow without a
// reload.

/** A change on the live stream that may change what someone holds. */
export const ACCESS_EVENTS = /^(permission\.revoked|staff\.roles_changed|role\.(scoped|updated))$/;

/** Two sorted lists the same, item for item. */
export const sameList = (a: readonly string[], b: readonly string[]): boolean =>
  a.length === b.length && a.every((x, i) => x === b[i]);

/** What the app says when the page open is no longer theirs. */
export const ACCESS_CLOSED = 'What you may see changed, so that page closed.';
